import Cookies from "js-cookie";

import { DEFAULT_ITEMS_PER_PAGE_VALUE } from "./consts";

export const itemsPerPageValue = () => {
  let cookiesItemsPerPageValue = Cookies.get("itemsPerPage");

  return cookiesItemsPerPageValue ?? DEFAULT_ITEMS_PER_PAGE_VALUE;
}